import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiBaseService } from './api.base.service';
import {
    PasswordSetupTokenViewModel,
    SetPasswordByTokenReqModel,
    SetPasswordResultViewModel,
} from 'core/models';

@Injectable({
    providedIn: 'root',
})
export class ApiPasswordSetupService extends ApiBaseService {
    private readonly publicHeaders = {
        Authorization: 'None',
    };

    constructor(http: HttpClient) {
        super(http, '/User/');
    }

    public validateToken(token: string): Observable<PasswordSetupTokenViewModel> {
        const params = new HttpParams({ fromObject: { token } });

        return this.get<PasswordSetupTokenViewModel>(
            'PasswordSetupToken',
            params,
            this.publicHeaders,
        );
    }

    public setPassword(
        payload: SetPasswordByTokenReqModel,
    ): Observable<SetPasswordResultViewModel> {
        return this.post<SetPasswordResultViewModel>(
            'SetPassword',
            payload,
            this.publicHeaders,
        );
    }
}
